import { Trans } from '@lingui/macro';
import { getStatusColor, getStatusName } from '../../../../utilities/StatusUtilities';
import { timeGranularityFormatter, granularityFormatter } from '../Formatters';
import { useTooltipStyles } from '../ChartTooltipStyles';

export default function TimeAndStatus({ chartDef, timeslice }) {
    const classes = useTooltipStyles();

    return (
        <>
            <div className={classes.header}>
                {chartDef.showGranularity ? (
                    <>
                        <div className={classes.timestampText}>
                            {timeGranularityFormatter(timeslice.x, timeslice.granularity)}
                        </div>
                        <div className={classes.granularityText}>{granularityFormatter(timeslice.granularity)}</div>
                    </>
                ) : (
                    <div className={classes.timestampText}>
                        {timeGranularityFormatter(timeslice.x, timeslice.granularity)}
                    </div>
                )}
            </div>
            {timeslice.status && (
                <div
                    className={classes.statusPlotbandPointHeader}
                    style={{ backgroundColor: getStatusColor(timeslice.status, 0.4) }}
                >
                    <Trans>Worst Status</Trans>:{' '}
                    <div className={classes.statusValue}>
                        <Trans id={getStatusName(timeslice.status)} />
                    </div>
                </div>
            )}
        </>
    );
}
